import React, { Component } from "react";

class BrightcoveVideo extends Component {
  render() {
    return (
      <div key={this.props.brightcoveVideoId} style={{ position: "relative", display: "block", maxWidth: "100%" }}>
        <div style={{ paddingTop: "56.25%" }}>
          <video
            data-video-id={this.props.brightcoveVideoId}
            data-account={this.props.brightcoveAccountId}
            data-player="default"
            data-embed="default"
            data-application-id
            className="video-js"
            controls
            id="video-player"
            style={{
              position: "absolute",
              top: "0px",
              right: "0px",
              bottom: "0px",
              left: "0px",
              width: "100%",
              height: "100%"
            }}
          />
          <script
            src={`http://players.brightcove.net/${this.props.brightcoveAccountId}/default_default/index.min.js`}
          />
        </div>
      </div>
    );
  }
}

export default BrightcoveVideo;



// WEBPACK FOOTER //
// ./src/containers/User/Common/VideoMain/BrightcoveVideo.js